module.exports = __webpack_public_path__ + "static/img/community06.76926b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/community06.jpg
// module id = 0Rum
// module chunks = 0